export type UserTypes = "SHIPPER_USER" | "SHIPPER_ADMIN";

export enum CostInputUoM {
  COUNT = "COUNT",
  CALL = "CALL",
  SECOND = "SECOND",
  MINUTE = "MINUTE",
  HOUR = "HOUR",
  DAY = "DAY",
  WEEK = "WEEK",
  MONTH = "MONTH",
  YEAR = "YEAR",
  FOOT = "FOOT",
  MILE = "MILE",
  LITER = "LITER",
  GALLON = "GALLON",
  CUSTOM = "CUSTOM",
  ONETIME = "ONETIME",
}

export interface CostItem {
  value?: number;
  uom?: CostInputUoM;
  description?: string;
}

export interface CostsObject {
  [key: string]: CostItem;
}
